import React from "react";
import "./BlogBanner.scss";

import dekstopimage from "../../../Assets/images/blog-desktop.jpg";
import mobileimage from "../../../Assets/images/blog-mobile.jpg";
import { useNavigate } from "react-router-dom";

const BlogBanner = () => {
  const navigator=useNavigate();
  const handleNavigate=()=>{
    navigator("/register");
  }
  return (
    <div className="blogBanner">
      <img
        src={dekstopimage}
        alt="banner"
        className="bannerDesktop"
      />
      <img
        src={mobileimage}
        alt="banner"
        className="bannerMobile"/>
      <div className="bannerContent">
        <h1>Get Online Homework Help</h1>
        <p>
          If you need something more than just online homework help,<br/>
          we have a team of experts who can help you with your homework.<br/>
          Our Experts Tutor Are Available 24/7, to help get grades in any way possible.
        </p>
        <div className="bannerButtons" onClick={handleNavigate}>
          <button className="btnPrimary">Register Now</button>
        </div>
      </div>

    </div>
  );
};

export default BlogBanner;